<template>
  <div class="content">
    <div class="col-md-8 flex-container-top">
      <base-button
        type="primary"
        round
        icon
        class="top-button-back"
        @click="$router.push('list')"
      >
        <i class="fa fa-arrow-left"></i>
      </base-button>

      <h2 v-if="!isEdit" class="text-center">Add Images</h2>
      <h2 v-if="isEdit" class="text-center">Edit Images</h2>
    </div>
    <div class="row">
      <div class="col-md-8">
        <card>
          <form>
            <div class="row">
            

              <div class="col-md-6">
                <base-input
                  v-if="isEdit"
                  type="text"
                  label="Name *"
                  maxlength="50"
                  placeholder="Name"
                  v-model="name"
                  readonly="name"
                >
                  <!-- {{ rstr.Name }} -->
                </base-input>
              </div>
            </div>

            <div class="row" style="margin: 5px">
              <div class="col-md-6">
                <base-button
                  v-if="!isEdit"
                  native-type="submit"
                  type="primary"
                  @click="AddEve()"
                  class="btn-fill"
                  :disabled="loading"
                  >Save</base-button
                >
              </div>

              <div
                style="
                  display: flex;
                  flex-direction: row;
                  justify-content: flex-end;
                "
                class="col-md-6"
              >
                <base-button
                  v-if="isEdit"
                  native-type="submit"
                  type="primary"
                  @click="UpdateEve()"
                  class="btn-fill"
                  :disabled="loading"
                  >Update</base-button
                >
              </div>
            </div>
          </form>
        </card>
      </div>

      <div class="col-md-4" v-for="user in [1]" v-bind:key="user">
        <card class="card-user">
          <p class="card-text"></p>
          <div class="author">
            <div class="block block-one"></div>
            <div class="block block-two"></div>
            <div class="block block-three"></div>
            <div class="block block-four"></div>
            <!-- <a href="javascript:void(0)">
              <img class="avatar" src="img/emilyz.jpg" alt="..." />
              <h5 class="title">Mike Andrew</h5>
            </a>
            <p class="description">Ceo/Co-Founder</p>-->

            <div class="col-md-12 col-sm-12" v-if="!isEdit">
              <h4 class="card-title">Image</h4>
              <image-upload
                :src="image"
                @change="onImageChange"
                select-text="Select Image"
              />
            </div>
            <div class="col-md-12 col-sm-12" v-if="isEdit">
              <h4 class="card-title">Event Image</h4>
              <image-upload
                :src="image"
                @change="onImageChange"
                select-text="Update Image"
              />
            </div>
          </div>
        </card>
      </div>
    </div>

    <div class="full-screen-loader" v-if="loading">
      <div class="sk-chase">
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { ImageUpload, BaseCheckbox, BaseRadio } from "src/components/index";
import { image } from "vee-validate/dist/rules";

export default {
  components: {
    ImageUpload,
    BaseRadio,
    BaseCheckbox,
  },
  data() {
    return {
      name: "",
      image: null,
      isEdit: false,
      loading: false,
      imageUploaded: false,
    };
  },

  async mounted() {
    debugger;
    console.log(this.$route.query.id);
    var id = this.$route.query.id;
    if (id == -1) {
      this.isEdit = false;
    } else {
      this.isEdit = true;
      let img = await this.$apiService.getCall("image/image/" + id);
      console.log(img);
      debugger;

      this.name = img.apidata.Data.name;

      this.image = img.apidata.Data.image;
      debugger;

      // let imgdata = await this.$apiService.getCall("image/image/" + id);
      debugger;
      // this.event = eve.apidata.Data.event;
      // this.loading = false;
      // console.log(imgdata);
      debugger;
    }
  },

  methods: {
    async UpdateEve() {
      var id = this.$route.query.id;

      if (!this.name) {
        this.$apiService.notify("Name is mandatory.");
        return;
      }

      if (!this.image) {
        this.$apiService.notify("Image is mandatory.");
        return;
      }

      this.loading = true;

      let imageUrl = this.image;
      if (this.imageUploaded) {
        imageUrl = await this.$apiService.uploadImage(this.image);
      }

      var update_image = {
        name: this.name,

        image: imageUrl,
      };

      var update_eve = await this.$apiService.postCall(
        "image/image-update/" + id,
        update_image
      );
      console.log(update_eve);

      this.$apiService.notify("Data has been updated.");
      this.$router.push("/images/list");
    },

    async AddEve() {
      debugger;

      if (!this.image) {
        this.$apiService.notify("Image is mandatory.");
        return;
      }

      if (!this.name) {
        this.$apiService.notify("Name is mandatory.");
        return;
      }
      debugger;

      const imageUrl = await this.$apiService.uploadImage(this.image);

      this.loading = true;

      var add_name = await this.$apiService.postCall("image/add-image", {
        name: this.name,
        image: imageUrl,
      });
      console.log(add_name);
      debugger;

      this.loading = false;
      // console.log(add_eve);

      this.$apiService.notify("Data has been added.", { duration: 2000 });
      this.$router.push("/images/list");
    },

    onImageChange(file) {
      this.image = file;
      this.imageUploaded = true;
    },
    // onLocChange(){
    //  this.address=
    // },
  },
};
</script>
